import CrudPage from "@/components/CrudPage";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const statusTag = (s) =>
  s === "online" ? <span className="sbc-tag tag-online"><span className="led led-green" /> online</span>
    : s === "degraded" ? <span className="sbc-tag tag-warn"><span className="led led-amber" /> degraded</span>
    : <span className="sbc-tag tag-offline"><span className="led led-gray" /> offline</span>;

const directionLabel = {
  entrada: "Entrada",
  saida: "Saida",
  ambos: "Entrada e saida",
};

export default function IPBXs() {
  const [cidLists, setCidLists] = useState([]);
  useEffect(() => {
    api.get("/cid-authorizations").then(({ data }) => setCidLists(data.filter((row) => row.enabled))).catch(() => setCidLists([]));
  }, []);
  return (
    <CrudPage
      title="IPBX externos"
      subtitle="PBX de entrada, saida ou ambos"
      endpoint="/ipbxs"
      testidPrefix="ipbxs"
      headers={["Nome", "Host", "Direcao", "CIDs de saida autorizados", "Porta", "Proto", "Codec", "Canais", "Vinculos", "Status real"]}
      renderRow={(r) => (
        <>
          <td className="font-medium">{r.nome}</td>
          <td className="font-mono">{r.host}</td>
          <td><span className="sbc-tag">{directionLabel[r.direcao || "ambos"]}</span></td>
          <td className="text-xs">{cidLists.find((item) => item.id === r.cid_lista_id)?.nome_lista || "Sem lista"}</td>
          <td className="font-mono">{r.porta}</td>
          <td className="font-mono uppercase text-[color:var(--text-secondary)]">{r.protocolo}</td>
          <td className="font-mono text-xs">{r.codec}</td>
          <td className="font-mono">{r.canais_max}</td>
          <td className="font-mono text-xs">{((r.refs?.dids || 0) + (r.refs?.rotas || 0) + (r.refs?.rotas_origem || 0) + (r.refs?.anuncios || 0)) ? `${r.refs?.dids || 0} DID · ${r.refs?.rotas_origem || 0} saida · ${r.refs?.rotas || 0} destino · ${r.refs?.anuncios || 0} anuncio` : "livre"}</td>
          <td>{r.enabled ? statusTag(r.status || "offline") : <span className="sbc-tag tag-offline">desativado</span>}</td>
        </>
      )}
      defaultValues={{ nome: "", host: "", direcao: "ambos", cid_lista_id: "", porta: 5060, protocolo: "udp", codec: "PCMA,PCMU", canais_max: 60, did_padrao: "", enabled: true }}
      fields={[
        { key: "nome", label: "Nome", placeholder: "PBX Matriz SP", full: true },
        { key: "host", label: "Host / IP", mono: true },
        { key: "direcao", label: "Utilizacao do IPBX", type: "select", options: [
          { value: "entrada", label: "Entrada" },
          { value: "saida", label: "Saida" },
          { value: "ambos", label: "Entrada e saida" }
        ] },
        { key: "cid_lista_id", label: "Lista de CIDs de saida autorizados", type: "select", full: true, hint: "Chamadas de saida com CID fora da lista serao negadas.", options: [
          { value: "", label: "Selecione uma lista" }, ...cidLists.map((item) => ({ value: item.id, label: `${item.nome_lista} - ${(item.itens || []).length} cliente(s)` }))
        ] },
        { key: "porta", label: "Porta", type: "number", mono: true },
        { key: "protocolo", label: "Protocolo", type: "select", options: [
          { value: "udp", label: "UDP" }, { value: "tcp", label: "TCP" }, { value: "tls", label: "TLS" }
        ]},
        { key: "codec", label: "Codecs", mono: true, full: true },
        { key: "canais_max", label: "Canais máx", type: "number", mono: true },
        { key: "did_padrao", label: "DID padrão para encaminhar", mono: true, placeholder: "+5511999999999", hint: "Usado quando a rota nao informar um DID especifico." },
        { key: "enabled", label: "Ativado", type: "toggle" },
      ]}
    />
  );
}
